import React, { useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ForcePasswordChange = () => {
  const { login } = useContext(AuthContext); // Use login function from AuthContext
  const location = useLocation();
  const navigate = useNavigate();

  // Retrieve username and password from location state
  const { username, password } = location.state || {};

  // Form data state
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { newPassword, confirmPassword } = formData;

    // Ensure passwords match
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Call the login API from AuthContext with updated credentials
      await login({ username, password, newPassword });

      // Navigate to the dashboard after successful password update
      navigate("/dashboard");
    } catch (err) {
      const { errorMessage } = err;
      setError(errorMessage || "Failed to set password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img
          alt="Your Company"
          src={`${process.env.PUBLIC_URL}/assets/hive.png`}
          className="mx-auto h-20 w-auto"
        />
        <h2 className="mt-10 text-center text-2xl font-bold tracking-tight text-[#414141]">
          Set Your Password
        </h2>
        <p className="mt-2 text-center text-sm text-gray-500">
          As this is your first login, please create a new password to continue.
        </p>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="newPassword"
              className="block text-sm font-medium text-[#414141]"
            >
              New Password
            </label>
            <div className="mt-2">
              <input
                id="newPassword"
                name="newPassword"
                type="password"
                required
                value={formData.newPassword}
                onChange={handleChange}
                autoComplete="new-password"
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-[#414141] outline outline-1 -outline-offset-1 outline-[#f7b22d] placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#f7b22d] sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="confirmPassword"
              className="block text-sm font-medium text-[#414141]"
            >
              Confirm Password
            </label>
            <div className="mt-2">
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                required
                value={formData.confirmPassword}
                onChange={handleChange}
                autoComplete="new-password"
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-[#414141] outline outline-1 -outline-offset-1 outline-[#f7b22d] placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#f7b22d] sm:text-sm"
              />
            </div>
          </div>

          {error && (
            <div className="text-red-500 text-sm mt-3">
              {error}
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="flex w-full justify-center rounded-md bg-[#f7b22d] px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-[#414141] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#f7b22d]"
            >
              {loading ? "Setting Password..." : "Set Password"}
            </button>
          </div>
        </form>

        <p className="mt-10 text-center text-sm text-gray-500">
          Changed your mind?{" "}
          <Link
            to="/loginTest"
            className="font-semibold text-[#f7b22d] hover:text-[#414141]"
          >
            Back to Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
